import {KeyTagForm} from "../../api/Model";
import {formPatcher, inputChange, SetState} from "../../util/FormHandlers";
import React, {useMemo} from "react";
import {Stack, TextField} from "@mui/material";
import ColorPicker from "../../components/color-picker/ColorPicker";


export function KeyTagFormComponent({form, setForm}: {
    form: KeyTagForm;
    setForm: SetState<KeyTagForm>;
}) {
    const handlers = useMemo(() => ({
        handleTagNameChange: inputChange(setForm, newValue => ({
            name: newValue,
        })),
        handleDescriptionChange: inputChange(setForm, newValue => ({
            description: newValue || null,
        })),
        handleColorChange: formPatcher(setForm, (newValue: string) => ({
            color: newValue,
        })),
    }), [setForm]);

    return form
        ? (
            <Stack spacing={2} direction="column" sx={{pt: 2}}>
                <TextField
                    required
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Tag Name"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={form.name}
                    onChange={handlers.handleTagNameChange}
                />
                <ColorPicker
                    required
                    margin="dense"
                    id="color"
                    label="Color"
                    fullWidth
                    variant="outlined"
                    value={form.color}
                    onChange={handlers.handleColorChange}
                    slotProps={{inputLabel: {shrink: true}}}
                />
                <TextField
                    margin="dense"
                    id="description"
                    label="Description"
                    type="text"
                    fullWidth
                    variant="outlined"
                    multiline
                    rows={3}
                    helperText="Enter a brief description of the tag"
                    value={form.description || ''}
                    onChange={handlers.handleDescriptionChange}
                />
            </Stack>
        )
        : null;
}